import { AxiosResponse, CancelToken } from "axios";

import {
  IClientAlertFilterConfig,
  IClientAlertSortConfig,
  IMakeSuggestionsFilterParams,
} from "models/api";
import { ClientAlertID, IClientAlertListResponse } from "models/clientAlert";
import {
  IMakeSuggestionsPerformersResponse,
  IMakeSuggestionsPerformersStatsResponse,
  INudge,
  ISuggestion,
} from "models/suggestion";

export interface IClientAlertsRequestParams {
  skip: number;
  take: number;
  sortOption?: IClientAlertSortConfig;
  filteringOptions?: IClientAlertFilterConfig;
  search?: string;
}

export interface IMakeSuggestionRequestParams {
  artist?: string;
  photo: string;
  comment: string;
  cduserid?: string;
}

export enum PatchOperation {
  Replace = "replace",
}

export interface IPatchItem {
  op: PatchOperation;
  path: string;
  value: string;
}

export type IPatchSuggestionEditMap = Record<string, IPatchItem[]>;

export interface ISetSuggestionRequestData {
  created?: IMakeSuggestionRequestParams[];
  deleted?: string[];
  edited?: IPatchSuggestionEditMap;
}

export type GetClientAlerts = (
  params: IClientAlertsRequestParams,
  cancellationToken?: CancelToken
) => Promise<IClientAlertListResponse>;

export type GetPerformers = (
  params: IMakeSuggestionsFilterParams,
  roleId: string,
  cancellationToken?: CancelToken
) => Promise<IMakeSuggestionsPerformersResponse>;

export type GetPerformersStats = (
  params: IMakeSuggestionsFilterParams,
  roleId: string,
  cancellationToken?: CancelToken
) => Promise<IMakeSuggestionsPerformersStatsResponse>;

export type GetSuggestions = (
  roleId: string,
  cancellationToken?: CancelToken
) => Promise<ISuggestion[]>;

export type DeleteSuggestions = (
  breakdownId: string,
  roleId: string,
  performersIds: string[],
  cancellationToken?: CancelToken
) => Promise<void>;

export type MakeSuggestions = (
  breakdownId: string,
  roleId: string,
  suggestion: IMakeSuggestionRequestParams[],
  cancellationToken?: CancelToken
) => Promise<void>;

export type EditSuggestions = (
  breakdownId: string,
  roleId: string,
  changes: IPatchSuggestionEditMap,
  cancellationToken?: CancelToken
) => Promise<void>;

export type SetSuggestions = (
  breakdownId: string,
  roleId: string,
  data: ISetSuggestionRequestData,
  cancellationToken?: CancelToken
) => Promise<void>;

export type GetNudge = (
  breakdownId: string,
  roleId: string,
  cancellationToken?: CancelToken
) => Promise<INudge>;

export type MakeNudge = (
  breakdownId: string,
  roleId: string,
  agencyId: string,
  cancellationToken?: CancelToken
) => Promise<void>;

export type SetClientAlerts = (
  clientAlertIds: ClientAlertID[]
) => Promise<AxiosResponse<void>>;
